import { type IconProps, makeIcon } from '../Icon.factory';

export type { IconProps };

const SearchIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-3.5-3.5" />
    </>
  ),
});
export function SearchIcon(props: IconProps) {
  return <SearchIconImpl {...props} />;
}

const MapIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2z" />
      <path d="M9 4v14M15 6v14" />
    </>
  ),
});
export function MapIcon(props: IconProps) {
  return <MapIconImpl {...props} />;
}

const ListIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M4 6h16M4 12h16M4 18h16" />
      <circle cx="3" cy="6" r="0.5" fill="currentColor" />
      <circle cx="3" cy="12" r="0.5" fill="currentColor" />
      <circle cx="3" cy="18" r="0.5" fill="currentColor" />
    </>
  ),
});
export function ListIcon(props: IconProps) {
  return <ListIconImpl {...props} />;
}

const InfoIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6M12 7.5v.5" />
    </>
  ),
});
export function InfoIcon(props: IconProps) {
  return <InfoIconImpl {...props} />;
}

const XIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M5 5l14 14M19 5 5 19" />
    </>
  ),
});
export function XIcon(props: IconProps) {
  return <XIconImpl {...props} />;
}

const BackIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M19 12H5M11 5 4 12l7 7" />
    </>
  ),
});
export function BackIcon(props: IconProps) {
  return <BackIconImpl {...props} />;
}

const PinIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M12 22s-7-7.5-7-13a7 7 0 1 1 14 0c0 5.5-7 13-7 13z" />
      <circle cx="12" cy="9" r="1.6" fill="currentColor" stroke="none" />
    </>
  ),
});
export function PinIcon(props: IconProps) {
  return <PinIconImpl {...props} />;
}

export function PawIcon({ size = 14, color = 'currentColor', className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      className={className}
      aria-hidden="true"
    >
      <ellipse cx="14" cy="19" rx="5.5" ry="4.5" fill={color} />
      <ellipse cx="7" cy="12" rx="2.2" ry="3" fill={color} />
      <ellipse cx="21" cy="12" rx="2.2" ry="3" fill={color} />
      <ellipse cx="10.5" cy="7.5" rx="2" ry="2.8" fill={color} />
      <ellipse cx="17.5" cy="7.5" rx="2" ry="2.8" fill={color} />
    </svg>
  );
}

const LeafIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M20 4c0 10-8 16-16 16 0-10 8-16 16-16z" />
      <path d="M4 20c6-6 10-8 16-12" />
    </>
  ),
});
export function LeafIcon(props: IconProps) {
  return <LeafIconImpl {...props} />;
}

const LoafIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M3 14a3 3 0 0 1 3-3h12a3 3 0 1 1 0 6H6a3 3 0 0 1-3-3z" />
      <path d="M7 14v-3M11 14v-3M15 14v-3" />
    </>
  ),
});
export function LoafIcon(props: IconProps) {
  return <LoafIconImpl {...props} />;
}

const TomatoIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="14" r="7" />
      <path d="M9 7c1 0 2 1 3 1s2-1 3-1M12 8V5" />
    </>
  ),
});
export function TomatoIcon(props: IconProps) {
  return <TomatoIconImpl {...props} />;
}

const FlowerIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="12" r="2" />
      <circle cx="12" cy="6" r="3" />
      <circle cx="18" cy="12" r="3" />
      <circle cx="12" cy="18" r="3" />
      <circle cx="6" cy="12" r="3" />
    </>
  ),
});
export function FlowerIcon(props: IconProps) {
  return <FlowerIconImpl {...props} />;
}

const CupIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M6 9h12l-1 11H7z" />
      <path d="M18 11h1a2.5 2.5 0 0 1 0 5h-1" />
      <path d="M9 5c0 1 1 1 1 2s-1 1-1 2M13 5c0 1 1 1 1 2s-1 1-1 2" />
    </>
  ),
});
export function CupIcon(props: IconProps) {
  return <CupIconImpl {...props} />;
}

const ChefIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M6 11a4 4 0 1 1 4-6 4 4 0 0 1 4 0 4 4 0 1 1 4 6v3H6z" />
      <path d="M6 14h12v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z" />
    </>
  ),
});
export function ChefIcon(props: IconProps) {
  return <ChefIconImpl {...props} />;
}

const CraftIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M4 20l3-7 6-6 4 4-6 6-7 3z" />
      <path d="M13 7l4 4" />
      <path d="M17 5l2 2" />
    </>
  ),
});
export function CraftIcon(props: IconProps) {
  return <CraftIconImpl {...props} />;
}

const FishIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M3 12c3-5 7-6 11-6 4 0 7 3 7 6s-3 6-7 6c-4 0-8-1-11-6z" />
      <path d="M3 12c-1 1-1 3 0 5M3 12c-1-1-1-3 0-5" />
      <circle cx="17" cy="11" r="0.8" fill="currentColor" />
    </>
  ),
});
export function FishIcon(props: IconProps) {
  return <FishIconImpl {...props} />;
}

const CheckIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: <path d="m5 12 5 5L20 7" />,
});
export function CheckIcon(props: IconProps) {
  return <CheckIconImpl {...props} />;
}

const PlusIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M12 5v14M5 12h14" />
    </>
  ),
});
export function PlusIcon(props: IconProps) {
  return <PlusIconImpl {...props} />;
}

const ShareIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="6" r="2.5" />
      <circle cx="18" cy="18" r="2.5" />
      <path d="m8 11 8-4M8 13l8 4" />
    </>
  ),
});
export function ShareIcon(props: IconProps) {
  return <ShareIconImpl {...props} />;
}

const ClockIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
});
export function ClockIcon(props: IconProps) {
  return <ClockIconImpl {...props} />;
}

const TargetIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    </>
  ),
});
export function TargetIcon(props: IconProps) {
  return <TargetIconImpl {...props} />;
}

const ChevRightIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: <path d="m9 5 7 7-7 7" />,
});
export function ChevRightIcon(props: IconProps) {
  return <ChevRightIconImpl {...props} />;
}

const MusicIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </>
  ),
});
export function MusicIcon(props: IconProps) {
  return <MusicIconImpl {...props} />;
}

const SunIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </>
  ),
});
export function SunIcon(props: IconProps) {
  return <SunIconImpl {...props} />;
}

const MoonIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  // Clean single-arc crescent, inset so the stroke doesn't get clipped
  // at the viewBox edges when rendered in a small round button.
  path: <path d="M19 13.5A8.5 8.5 0 0 1 10.5 5a8.5 8.5 0 1 0 8.5 8.5z" />,
});
export function MoonIcon(props: IconProps) {
  return <MoonIconImpl {...props} />;
}

const ExternalLinkIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M10 5H5v14h14v-5" />
      <path d="M13 3h8v8" />
      <path d="M13 11 21 3" />
    </>
  ),
});
export function ExternalLinkIcon(props: IconProps) {
  return <ExternalLinkIconImpl {...props} />;
}

const InstagramIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
    </>
  ),
});
export function InstagramIcon(props: IconProps) {
  return <InstagramIconImpl {...props} />;
}

const FacebookIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  ),
});
export function FacebookIcon(props: IconProps) {
  return <FacebookIconImpl {...props} />;
}

const GlobeIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </>
  ),
});
export function GlobeIcon(props: IconProps) {
  return <GlobeIconImpl {...props} />;
}

const CarIconImpl = makeIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M4 14h16M6 14l2-6h8l2 6" />
      <path d="M4 14v4h3v-2h10v2h3v-4" />
      <circle cx="7.5" cy="16.5" r="0.6" fill="currentColor" />
      <circle cx="16.5" cy="16.5" r="0.6" fill="currentColor" />
    </>
  ),
});
export function CarIcon(props: IconProps) {
  return <CarIconImpl {...props} />;
}

export function CashIcon({
  size = 18,
  color = 'currentColor',
  strokeWidth = 1.7,
  className,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 18"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <rect x="1" y="1" width="24" height="16" rx="2" />
      <circle cx="13" cy="9" r="3.5" />
      <circle cx="5" cy="9" r="0.7" fill={color} />
      <circle cx="21" cy="9" r="0.7" fill={color} />
    </svg>
  );
}
